import {register} from '@shopify/theme-sections'
import $ from 'jquery'
import 'slick-carousel'
import '../../styles/components/carousel.scss'
import '../../styles/sections/section-testimonial-v2.scss'

export default register(`section-testimonial-v2`, {
  onLoad() {
    $(`.testimonial-v2-slider`).slick(
        {
          "autoplay": false,
          "slidesToShow": 3,
          "slidesToScroll": 3,
          "arrows": false,
          "dots": true,
          "responsive": [{
            "breakpoint": 868,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "arrows": false,
              "dots": true}
          }]
        }
    )
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
      $(`.testimonial-v2-slider`).unslick()
  },
})
